import React, { PropsWithChildren, useEffect } from 'react';
import Highcharts from 'highcharts';
import 'highcharts/modules/accessibility';
import 'highcharts/modules/annotations';
import HighchartsReact from 'highcharts-react-official';
import styles from './highchart.module.scss';
import 'highcharts/modules/no-data-to-display';
import { trackClick } from 'src/hooks/useAdobeTags';
import { useLocation } from 'react-router';

interface HighchartProps {
    title: string;
    options: Highcharts.Options;
    withDLS?: boolean;
    'data-cy'?: string;
    tagName?: string;
    xAxisLabels?: JSX.Element;
    className?: string;
}

export default function Highchart({
    title,
    options,
    withDLS,
    'data-cy': dataCy,
    tagName,
    children,
    className,
    xAxisLabels
}: PropsWithChildren<HighchartProps>): JSX.Element {
    const { pathname } = useLocation();
    // manually overwrite aria-label so they don't confict when multiple charts are on one page
    useEffect(() => {
        // ensure we get the correct chart by using the title aria-label
        const zoomElement = document.querySelector(
            `[aria-label="${title}. Highcharts interactive chart."] [aria-label="Axis zoom"]`
        );
        zoomElement?.setAttribute('aria-label', `${title} Axis zoom`);
    });

    return (
        <div
            className={`${styles.container} ${withDLS ? 'dls-hc pad-responsive dls-white-bg' : ''} ${className}`}
            data-cy={dataCy}
            onMouseEnter={() => {
                trackClick(pathname, tagName);
            }}
        >
            {children}
            <HighchartsReact highcharts={Highcharts} options={options} />
            {xAxisLabels}
        </div>
    );
}
